import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {LendioState} from "../LendioState";
import {computed, observable} from "mobx";
import {
    IBankAccountsData,
    IManuallyBankAccountDetails,
    IQuickSignUpSetStateRequest
} from "../../../../../../shared/src/functions/membersApi/types/ISignupProcess";
import FirebaseSignUpService from "../../../../services/firebase/functions/FirebaseSignUpService";
import {IQuickSignUpRetriveStateRequest, LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";

export class ShortSignupStore extends ApiCallObservable {
    @observable public _currentComponent: number = LendioState.welcome;
    @observable public _uid: string = '';
    @observable public _cowork: string = '';
    @observable public showVerified: boolean = false;
    @observable public isVerified: boolean = false;
    @observable public _loading: boolean = false;
    @observable public _isPaymentError: boolean = false;
    @observable public paymentError: string = "";
    @observable public navigateTo404: boolean = false;
    @observable public navigateToExpiredOffer: boolean = false;
    @observable public showFinishPaymentAnimation: boolean = false;
    @observable public _loanAmount: number;
    @observable public monthlyRepayment: number = 0;
    @observable public monthlyPaymentAmount: number = 0;
    @observable public installments: number = 0;
    @observable public navigationController = {verification: false};
    @observable public formInput: any = {
        financial: {},
        plans: {plansValue: LeadPlanType.Loan},
        verification: {}
    };
    @observable public accounts: IBankAccountsData;

    @computed
    get currentComponent() {
        return this._currentComponent;
    };

    @computed
    get getmonthlyPaymentAmount() {
        return this.monthlyPaymentAmount;
    };

    get isLoading() {
        return this._loading;
    };

    public setIsLoading = (val: boolean) => {
        this._loading = val;
    };

    public setPaymentError = (val: boolean) => {
        this._isPaymentError = val;
    };

    get isPaymentError() {
        return this._isPaymentError;
    }

    get loanAmount() {
        return this._loanAmount;
    }

    public setLoanAmount(val: number) {
        this._loanAmount = val;
    }


    get uid() {
        return this._uid;
    }

    public setUid =(val: string) => {
        this._uid = val;
    }

    get cowork() {
        return this._cowork;
    }

    public setCowork =(val: string) => {
        this._cowork = val;
    }

    public updateCurrentComponent = (newComponent: number) => {
        window.scrollTo(0, 0);
        this._currentComponent = newComponent;
    };

    public setInputValue = (formPage: string, propertyName: string, value: any) =>  {
        this.formInput[formPage][propertyName] = value;
    };

    public updateBankDetails = (data: any) => {
        this.formInput.financial.bankInfo = data;
        this.showVerified = true;
        setTimeout(() => {
            this.showVerified = false;
        }, 1700);
        const params = {
            uid: this.uid,
            cowork: this.cowork,
            data: {
                financial: {
                    amount: this.formInput.financial.amount,
                    installments: this.formInput.financial.installmentPlan,
                    fundReason: this.formInput.financial.fundReason,
                },
                bankInfo: data
            }
        }
        this.setLendioApplicationData(params, LendioState.bankSelection);
    };

    public updateLendioId = (data: any) => {
        this.formInput.verification.lendioId = "sending";
        const params: IQuickSignUpSetStateRequest = {
            uid: this.uid,
            cowork: this._cowork,
            data: {
                lendioIDFile: data,

            }
        };
        this.formInput.verification.lendioId = data;
        this.setLendioApplicationData(params);
    }

    public updateVerification = () => {
        const params: IQuickSignUpSetStateRequest = {
            uid: this.uid,
            cowork: this._cowork,
            data: {
                ssn: this.formInput.verification.leadSSN
            }
        };
        this.setLendioApplicationData(params, LendioState.payment);
    };

    public updatePayment = (cardInfo: any) => {
        this.setPaymentError(false);
        const params: IQuickSignUpSetStateRequest = {
            uid: this.uid,
            cowork: this._cowork,
            data: {
                cardInfo
            }
        };
        this.setLendioApplicationData(params, LendioState.thankYou);
    };

    public setDataAndCurrentComponentFromResponse = (response: any) => {
        this.formInput = {...response.data};
        this.formInput.verification = {};
        this.formInput.plans = {plansValue: LeadPlanType.Loan};
        this.isVerified = Boolean(response.data.isVerified);
        if(this.formInput.isPaymentFinished) {
            this.updateCurrentComponent(LendioState.thankYou);
        } else if(this.formInput.photoID || response.data.passedVerification) {
            this.updateCurrentComponent(LendioState.payment);
        }else if (response.data.bankSelected) {
            this.updateCurrentComponent(LendioState.verification);
        } else if(response.data.bankAccounts || response.data.bankInfo) {
            this.accounts = response.data.bankAccounts;
            this.updateCurrentComponent(LendioState.bankSelection);
        }  else if(response.data.bankInfo) {
            this.updateCurrentComponent(LendioState.verification);
        }
    };

    public async getApplicationData(uid: string, cowork:string) {
        this.setIsLoading(true);
        const params: IQuickSignUpRetriveStateRequest = {
            uid,
            cowork
        };
        const response = await FirebaseSignUpService.retrieveLendioUserData(params);
        setTimeout(() => {
            this.setIsLoading(false);
        }, 1200);
        if(response.ok) {
            if(response.data.redirect) {
                this.navigateToExpiredOffer = true;
            }else {
                this.setDataAndCurrentComponentFromResponse(response);
            }
        }else {
            this.navigateTo404 = true;
        }
    }

    public async setLendioApplicationData(params: IQuickSignUpSetStateRequest, nextScreen?: LendioState){
        const response = await FirebaseSignUpService.updateLendioUserData(params);
        this.setIsLoading(false);
        if(response.ok) {
            if(response.data.isFinished) {
                this.showFinishPaymentAnimation = true;
                setTimeout(() => {
                    this.showFinishPaymentAnimation = false;
                    this.updateCurrentComponent(LendioState.thankYou);
                }, 5000);
            }
            if(response.data.bankAccounts) {
                this.accounts = response.data.bankAccounts;
            }
            if(response.data.installmentPlan) {
                this.handlePaymentResponse(response.data)
            } else if(nextScreen) {
                this.updateCurrentComponent(nextScreen);
            }
        } else {
            if(nextScreen === LendioState.thankYou) {
                this.setPaymentError(true)
                this.paymentError = response.error!.message!
            }
        }
    }

    public async updateSelectedAccountDetails(bankAccountDetails: IManuallyBankAccountDetails | string) {
        this.setIsLoading(true);
        const params: IQuickSignUpSetStateRequest = {
            uid: this.uid,
            cowork: this.cowork,
            data: {
                bankAccountDetails
            }
        };
        this.setLendioApplicationData(params, LendioState.verification)
    }

    private handlePaymentResponse = (response: any) => {
        this.isVerified = response.finalPrice;
        this.monthlyPaymentAmount = response.montlyFee;
        this.monthlyRepayment     = response.repaymentAmount;
        this.installments         = response.installmentPlan;
        this.updateCurrentComponent(LendioState.payment);
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/LendioStore.ts